import { ITab } from 'components/tabs';

import { HowToUseProduct } from './HowToUseProduct';
import { ReturningPolicy } from './ReturningPolicy';
import { ThankYouTab } from './ThankYouTab';

export const WELCOME_MESSAGE = 'loi-cam-on';

export const RETURNING_POLICY = 'chinh-sach-doi-tra';

export const HOW_TO_USE_PRODUCT = 'huong-dan-su-dung';

export const aboutUsTabs: ITab[] = [
  {
    label: 'about_us.labels.thanks',
    anchorLink: WELCOME_MESSAGE,
    content: <ThankYouTab />
  },
  {
    label: 'about_use.labels.returning_policy',
    anchorLink: RETURNING_POLICY,
    content: <ReturningPolicy />
  },
  {
    label: 'about_us.labels.guide',
    anchorLink: HOW_TO_USE_PRODUCT,
    content: <HowToUseProduct />
  }
];
